<template>
  <div id="all-vehicle-table" style="margin-top: 24px">
    <QS-h4-title title="全部车辆" />
    <QS-common-table
      :max-height="400"
      :data="tableData"
      :columns="columns"
      :pagination="false"
      :span-method="objectSpanMethod"
    />
  </div>
</template>
<script>
import config from './config'
import mixin from '../../../mixins/vehicleProperty'

export default {
  mixins: [mixin],
  props: ['tableData'],
  data() {
    const { columns } = config.call(this)
    return {
      columns,
    }
  },
  methods: {
    // 列合并逻辑逻辑
    objectSpanMethod(params) {
      const { columnIndex } = params
      if (columnIndex === 0) {
        return this.cellMerge(this.tableData, params)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
#all-vehicle-table ::v-deep .el-table .el-table__body-wrapper tr:first-child {
  td {
    border-bottom: none !important;
  }
}
</style>
